<template>
  <div class="grid-wrapper">
    <!-- HEADER -->
    <div class="grid header" :style="{ gridTemplateColumns: gridColumns }">
      <!-- FILA 1 -->
      <div class="cell header-cell franja-cell">Franja</div>
      <div v-for="dia in dias" :key="dia.dia" class="cell header-cell">
        {{ dia.dia }}
      </div>

      <!-- FILA 2 -->
      <div class="cell header-cell franja-cell"></div>
      <div v-for="dia in dias" :key="dia.dia + '-sub'" class="cell header-cell">
        <div class="canchas-grid">
          <div
            v-for="n in maxCanchasPorDia[dia.dia] || 1"
            :key="n"
            class="subcancha"
          >
            Cancha{{ n }}
          </div>
        </div>
      </div>
    </div>

    <!-- BODY -->
    <div class="grid body" :style="{ gridTemplateColumns: gridColumns }">
      <div v-for="franja in franjas" :key="franja.hora" class="franja-row">
        <!-- HORA -->
        <div class="cell franja-cell">
          <div>{{ franja.hora }}</div>
          <small>{{ franja.tipo }}</small>
        </div>

        <!-- CELDAS -->
        <div v-for="dia in dias" :key="dia.dia + franja.hora" class="cell">
          <div class="canchas-grid">
            <div
              v-for="n in maxCanchasPorDia[dia.dia] || 1"
              :key="n"
              class="cancha-activa-programacion"
            >
              <template
                v-if="
                  partidos &&
                    partidos[dia.dia] &&
                    partidos[dia.dia][franja.hora] &&
                    partidos[dia.dia][franja.hora][n]
                "
              >
                <div
                  :style="
                    `background:${
                      partidos[dia.dia][franja.hora][n].local.color
                    }`
                  "
                  class="nombre-categoria"
                >
                  <span>
                    {{ partidos[dia.dia][franja.hora][n].local.categoria }}
                  </span>
                  <div style="margin-left: 2px">
                    (#
                    {{ partidos[dia.dia][franja.hora][n].num_fecha }})</div
                  >
                  <!-- <span style="color:white; "
                    >/{{ partidos[dia.dia][franja.hora][n].etapa }}</span
                  > -->
                </div>
                <div class="nombre-equipo">
                  <img
                    :src="partidos[dia.dia][franja.hora][n].local.foto"
                    alt="ND"
                    width="17"
                  />
                  <span>
                    {{ partidos[dia.dia][franja.hora][n].local.equipo }}
                  </span>
                </div>

                <div class="vs">vs</div>

                <div class="nombre-equipo">
                  <img
                    :src="partidos[dia.dia][franja.hora][n].visita.foto"
                    alt="ND"
                    width="17"
                  />
                  <span>
                    {{ partidos[dia.dia][franja.hora][n].visita.equipo }}
                  </span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  props: {
    dias: Array,
    franjas: Array,
    partidos: Object,
  },

  setup(props) {
    const maxCanchasPorDia = computed(() => {
      const result = {}

      if (!props.partidos) return result

      Object.keys(props.partidos).forEach(dia => {
        let max = 1

        Object.values(props.partidos[dia]).forEach(hora => {
          const cantidadCanchas = Object.keys(hora).length
          if (cantidadCanchas > max) max = cantidadCanchas
        })

        result[dia] = max
      })

      return result
    })

    const ANCHO_CANCHA = 104
    const GAP = 4
    const PADDING_X = 56

    const gridColumns = computed(() => {
      const franjaCol = '80px'

      const diasCols = props.dias.map(dia => {
        const canchas = maxCanchasPorDia.value[dia.dia] || 1

        const width = canchas * ANCHO_CANCHA + (canchas - 1) * GAP + PADDING_X

        return `${width}px`
      })

      return [franjaCol, ...diasCols].join(' ')
    })

    return {
      gridColumns,
      maxCanchasPorDia,
    }
  },
}
</script>

<style scoped>
.grid-wrapper {
  max-height: 500px;
  overflow: auto;
  border: 1px solid #ccc;
}

.grid {
  display: grid;
}

.header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #f8f9fa;
}

.body {
  grid-auto-rows: 75px;
}

.franja-row {
  display: contents;
}

.cell {
  border: 1px solid #e1e0e0;
  padding: 0 28px;
  display: flex;
}

.franja-cell {
  position: sticky;
  left: 0;
  background: #f1f3f5;
  z-index: 5;
  font-weight: 600;
}

.canchas-grid {
  display: inline-flex; /* Cambiado para que crezca según el contenido */
  gap: 4px;
}

.cancha-activa-programacion {
  width: 114px; /* Ancho fijo para cada cancha */
  height: 65px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #f9f9f9;
  font-size: 9px;
  /* padding: 4px; */
  text-align: center;
}
.subcancha {
  width: 104px; /* Ancho fijo para cada cancha */
  background: #fffdfd;
  font-size: 9px;
  padding: 4px;
  text-align: center;
}

.vs {
  font-size: 7px;
  color: #888;
  text-align: center;
}
.nombre-equipo {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0; /* 🔥 CLAVE para que funcione ellipsis */
}
.nombre-categoria {
  display: flex;
  align-items: center;
  color: white;
  background: rgb(25, 118, 210);
  border-radius: 6px 6px 0px 0px;
  padding-left: 6px;
  margin-bottom: 3px;
}

.nombre-equipo span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 8px;
}
</style>
